'use client';

// import { useScript } from 'components/index';
import CustomLink from 'components/shared/CustomLink';
import Script from 'next/script';
import { useTranslations } from 'next-intl';

import styles from './ApplicationErrorComponent.module.css';

function canCreateWebGLContext(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
  } catch {
    return false;
  }
}

function initUnicornStudio(): void {
  try {
    const studio = (window as any).UnicornStudio;
    if (!studio?.init || studio.isInitialized || !canCreateWebGLContext()) {
      return;
    }
    studio.init();
    studio.isInitialized = true;
  } catch {
    // WebGL unavailable — static copy still renders
  }
}

export const ApplicationErrorComponent = () => {
  const t = useTranslations('common');
  return (
    <>
      <section className={styles.root}>
        <div
          data-us-project="MekbJaIxD2semiAhBBDT"
          style={{ width: '100%', height: '100%' }}
        ></div>

        <div className={styles.contentContainer}>
          <div className={styles.content}>
            <p>
              {t('applicationErrorComponent.text.looksLikeOur')}
              <br />
              {t('applicationErrorComponent.text.tryRefreshingCome')}
            </p>

            <CustomLink
              href={{
                pathname: '/',
              }}
            >
              {t('applicationErrorComponent.customLink.takeMeHome')}
            </CustomLink>
          </div>
        </div>
      </section>
      <Script
        src={'https://cdn.unicorn.studio/v1.3.2/unicornStudio.umd.js'}
        onLoad={initUnicornStudio}
      />
    </>
  );
};
